import PageLayout from "../../components/UI/Layout/PageLayout";
import { Outlet } from "react-router-dom";

export default function RootPage() {
  return (
    <PageLayout isBailleur>
      <Outlet />
    </PageLayout>
  );
}
